import React from 'react';
import {ContactForm} from 'components/contact';

class ContactBusiness extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    let location = {lat: this.props.business.geoLat, lng: this.props.business.geoLng};
    let gmap = new window.google.maps.Map(document.getElementById('map'), {
      center: location,
      zoom: 13
    });
    new window.google.maps.Marker({
      position: location,
      map: gmap
    });
  }

  render() {
    return (
      <section className="center">
        <div className="contact-business">
          <div className="contact-S-wrapper">
            <div className="contact-S-left-address">
              <div className="contact-S-address">
                <div className="contact-S-address-content">
                  <i className="fa fa-building-o contact-S-address-icon"/>
                  <span className="contact-S-address-des"><span className="strong-content">TRỤ SỞ: &nbsp;</span>{this.props.business.address}</span>
                </div>
                <div className="contact-S-address-content">
                  <i className="fa fa-envelope contact-S-address-icon"/>
                  <span className="contact-S-address-des"><span className="strong-content">Email: &nbsp;</span>{this.props.business.email}</span>
                </div>
                <div className="contact-S-address-content">
                  <i className="fa fa-phone contact-S-address-icon"/>
                  <div className="contact-S-address-des-wrap">
                    <span className="contact-S-address-des"><span className="strong-content">Tư vấn dịch vụ: &nbsp;</span>{this.props.business.phone}</span>
                  </div>
                </div>
              </div>
              <div className="contact-S-map">
                <div id="map">map</div>
              </div>
            </div>
            <div className="contact-S-right-forrm">
              <ContactForm businessId={this.props.business.id}/>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ContactBusiness;



// WEBPACK FOOTER //
// ./components/business/business-page/ContactBusiness.jsx